import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {colors} from 'shells/colors/colors';
import {SelectedFieldCard} from 'shells/form/sidebar-fields/selected-field-card';
import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import type {EntityType} from 'nutshell-graphql-types';

type Props = FieldProps & {
    onChange: (newValue: ListOptionWithCount) => any;
    onRemove: () => void;
    updateOptions: (newOption: ListOptionWithCount) => void;
    refetch: () => Promise<any>;
    optionFields: ListOptionWithCount[];
    selectedOptions: string[];
    createComponent: React.ComponentType<any>;
    entityType: EntityType;
    autoFocus?: boolean;
};

export function SelectFieldCreateable(props: Props) {
    const inputValue = props.input.value;
    const {autoFocus = true} = props;

    let loading = false;

    const selectedValue = inputValue
        ? // @ts-expect-error
          props.optionFields.find((field) => field.value === inputValue)
        : undefined;

    if (!selectedValue) {
        loading = true;
    }

    if (inputValue) {
        return (
            <SelectedFieldCard
                name={selectedValue ? selectedValue.label : ''}
                onRemove={props.onRemove}
                isLoading={loading}
                borderColor={
                    selectedValue && selectedValue.colorName
                        ? // @ts-expect-error
                          colors[selectedValue.colorName]
                        : undefined
                }
            />
        );
    }

    // filter out already selected items from the list of available items
    const availableOptions = props.optionFields.filter(
        // @ts-expect-error
        (audience) => !props.selectedOptions.find((field) => field === audience.value)
    );

    const CreateComponent = props.createComponent;

    return (
        <CreateComponent
            {...props}
            options={availableOptions}
            autoFocus={autoFocus}
            isCreateable={true}
            selectedId={undefined}
        />
    );
}
